import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";

const ComingSoonSection = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(90deg, #18666f 0%, #085b66 100%)",
        py: { xs: 6, md: 8 },
        textAlign: "center",
        color: "#fff",
        mt: 6,
      }}
    >
      <Container maxWidth="md">
        <AccessTimeFilledIcon
          sx={{ fontSize: 60, color: "#fff", mb: 2, opacity: 0.9 }}
        />
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "26px", md: "34px" },
            mb: 2,
            letterSpacing: "0.5px",
          }}
        >
          Membership Registration Coming Soon
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "15px", md: "17px" },
            maxWidth: 600,
            mx: "auto",
            mb: 3,
            color: "rgba(255,255,255,0.9)",
            lineHeight: "28px",
          }}
        >
          We’re building something exciting! Soon, you’ll be able to register for
          our exclusive membership program — offering early access to projects,
          special pricing, and personalized real estate updates.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#fff",
            color: "#025253ff",
            fontWeight: 600,
            borderRadius: "25px",
            px: 4,
            py: 1.5,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
        >
          Notify Me
        </Button>
      </Container>
    </Box>
  );
};

export default ComingSoonSection;
